

























































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import { Country } from '@/data/models/country.model';
import { Provincia } from '@/data/models/provincia.model';
import { ClassType } from 'class-transformer/ClassTransformer';
import { CrudService } from '@/data/services/crud.service';

@Component
export default class LuogoFilter extends Vue {

	advancedSearch: Search;
	searchParam: any = new class {
		name?: string = '';
		country?: Country;
		province?: Provincia;
		aslcode?: string = ''
	};

	@Inject('CrudService') provinciaCrudService!: CrudService<Provincia>;
	provinciaClass: ClassType<Provincia> = Provincia;

	@Inject('CrudService') countryCrudService!: CrudService<Provincia>;
	countryClass: ClassType<Country> = Country;

	state!: State;

	constructor() {
		super();
		this.state = store;
		this.advancedSearch = new Search('asl');
	}

	search() {
		this.advancedSearch.reset();
		if (this.searchParam.name) this.advancedSearch.addLikeFilter('name', this.searchParam.name);
		if (this.searchParam.country) this.advancedSearch.addSimpleFilter('country', this.searchParam.country.name);
		if (this.searchParam.province) this.advancedSearch.addSimpleFilter('province', this.searchParam.province.descrizione);
		if (this.searchParam.aslcode) this.advancedSearch.addLikeFilter('aslcode', this.searchParam.aslcode);
		this.$emit('search', this.advancedSearch);
	}

	reset() {
		this.searchParam.name = undefined;
		this.searchParam.country = undefined;
		this.searchParam.province = undefined;
		this.searchParam.aslcode = undefined;
		this.search();
	}

}
